import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { withRouter } from 'react-router-dom'
import { logError, isEmpty, updateDocumentTitle, getIconColor } from 'src/utils/helpers'
import 'src/theme/animation.less'
import styles from './List.module.less'
import { SidebarCard } from 'src/components/SidebarCard/SidebarCard'
import { Text, Image } from '@chakra-ui/react'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon/index'

class List extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      active: '',
    }
    this.isScrolledToItem = false
    this.listRefs = []
  }

  static contextTypes = {
    router: PropTypes.object,
  }

  static defaultProps = {
    preventActiveState: false,
  }

  componentDidMount() {
    const {
      currentlyOpenFeature,
      isMainMenu,
      preventActiveState,
      user,
      location,
      history,
      items,
      setCurrentlyOpenFeature,
    } = this.props
    const activeItem = items.find(item => item.url === location.pathname)
    if (activeItem) {
      setCurrentlyOpenFeature(activeItem.id)
    }
    items.length &&
      items.map(item => {
        const isActive = isMainMenu && item.id === currentlyOpenFeature && !preventActiveState

        if (isActive && isMainMenu && !item.settings.isLoginRequired && !user) {
          if (
            location.pathname !== item.url &&
            location.pathname === '/auth/login' &&
            item.id !== 'payments'
          ) {
            history.push(item.url)
          }
        }
      })
  }

  handleDocumentTitle = item => {
    const { brand, useDefaultDocumentTitle } = this.props
    const documentTitle = useDefaultDocumentTitle || !item.title ? brand.name : item.title
    updateDocumentTitle(documentTitle)

    return documentTitle
  }

  goTo = item => e => {
    e.preventDefault()
    const {
      onClick,
      history,
      isMainMenu,
      setCurrentlyOpenFeature,
      closeSidebar,
      isWidget,
      areAppActionsDisabled,
    } = this.props
    // prevent history push if app actions desabled and double clicked on sidebar card
    // if (areAppActionsDisabled === true || (isMainMenu && (item.feature === currentlyOpenFeature))) {
    //   return false
    // }

    if (areAppActionsDisabled === true) {
      return false
    }

    if (
      isMainMenu &&
      typeof setCurrentlyOpenFeature === 'function' &&
      item.page &&
      item.page.type !== 'externalUrl'
    ) {
      setCurrentlyOpenFeature(item.id)
      if (!isWidget) {
        this.handleDocumentTitle(item)
      }
    }

    if (typeof closeSidebar === 'function') {
      closeSidebar()
    }

    if (typeof onClick === 'function') {
      onClick(item)
    }

    if (item.hasOwnProperty('url') && item.url) {
      if (item.url.startsWith('http')) {
        window.open(item.url, '_blank')
      } else {
        let listItem = {
          ...item,
        }
        if (item.leftIconType === 'component') {
          // left icon is react component it can't be pushed to the history state
          delete listItem.leftIcon
        }
        history.push({
          pathname: item.url,
          state: {
            listItem,
          },
        })
        return true
      }
    }
  }

  renderCheckbox = type => {
    if (type === 'Checked') {
      return (
        <div className={styles.checked + ' kiosk-color-primary--border-color'}>
          <FontAwesomeIconComponent
            className='kiosk-color--brand-color'
            icon={['far', 'check']}
            size='xs'
            type='accent'
          />
        </div>
      )
    } else {
      return <div className={styles.unchecked + ' kiosk-color-primary--border-color'} />
    }
  }

  renderLeftIcon = item => {
    if (item.image) {
      return (
        <Image
          w={'100%'}
          h={'100%'}
          borderRadius={item.radius ? item.radius : '5px'}
          objectFit='cover'
          src={item.image}
          alt={`${item.name}-icon`}
        />
      )
    }

    if (item.leftIconType === 'customImage' || item.leftIconType === 'customSvg') {
      return (
        <Image
          w={'100%'}
          h={'100%'}
          borderRadius={item.radius ? item.radius : '5px'}
          objectFit={item.leftIconType === 'customSvg' ? 'scale-down' : 'cover'}
          src={item.leftIcon}
          alt={`${item.name}-icon`}
        />
      )
    }

    if (item.leftIconType === 'component') {
      const color = getIconColor()
      return React.cloneElement(item.leftIcon, { color })
    }

    if (item.nameInitials) {
      return <Text fontSize={'20px'}> {item.nameInitials} </Text>
    }

    let type = item.leftIcon

    if (!type) {
      return null
    }

    const { styleVariation, styleVariationDesktop } = this.props

    if (type === 'Person') {
      type = ['far', 'user']
    }

    if (type === 'Vehicle') {
      type = ['far', 'car']
    }

    if (type === 'Property') {
      type = ['far', 'house']
    }

    if (type === 'Other') {
      type = ['far', 'memo']
    }
    if (type === 'Checked' || type === 'CheckedNo') {
      return this.renderCheckbox(type)
    } else {
      const classNames = cx({
        // [classNameLeftIconSvg]: !!classNameLeftIconSvg,
        // [styles.leftIconSvg]: true,
        [styles.leftIconSvgDesktopBlocks]:
          styleVariationDesktop && styleVariationDesktop === 'blocks',
        'kiosk-color--primary-color': styleVariation && styleVariation === 'checklist',
      })
      return (
        <FontAwesomeIconComponent
          className={classNames}
          icon={type}
          size='sm'
          type='card-font'
          width={item.iconWidth}
        />
      )
    }
  }

  /**
   * Collect all list item refs in an array.
   *
   * @param refKey Array key by which we can later find a specific ref.
   * @param ref Actual react ref
   */
  updateRefs = (refKey, ref) => {
    this.listRefs[refKey] = ref
  }

  /**
   * Try to find list item ref.
   *
   * @param refKey
   * @return {null|*}
   */
  getListRef = refKey => {
    try {
      if (this.listRefs && this.listRefs.hasOwnProperty(refKey)) {
        return this.listRefs[refKey]
      }
      return null
    } catch (e) {
      return null
    }
  }

  /**
   * Scroll to ref element so that it's centered vertically in the middle of the screen.
   *
   * @param refKey
   * @return {boolean}
   */
  scrollTo = refKey => {
    try {
      const ref = this.getListRef(refKey)
      if (ref) {
        ref.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })

        return true
      }
      return false
    } catch (e) {
      logError('Scroll to list item', e, 0)
      return false
    }
  }

  renderItems = items => {
    const {
      currentlyOpenFeature,
      isMainMenu,
      classNameListItem,
      preventActiveState,
      isColumn,
      isColumnReverse,
      avatarCircle,
      isFullWidth,
      noMargin,
      isProfile,
      isServices,
      user,
      isOverflown,
    } = this.props

    this.isScrolledToItem = false

    if (!items.length) {
      return <></>
    }
    return (
      items.length &&
      items.map((item, itemKey) => {
        if (
          item.disable ||
          (isMainMenu && !item.isEnabled) ||
          (isMainMenu && item.settings.isHiddenUnlessLoggedIn && !user)
        ) {
          return <></>
        }
        const isActive = isMainMenu && item.id === currentlyOpenFeature && !preventActiveState

        if (isActive) {
          this.setState({ active: item.id })
        }

        const error =
          item && item.hasOwnProperty('errorMessage') && !isEmpty(item.errorMessage)
            ? item.errorMessage
            : null

        // Try to scroll to the item if there is an error and we didn't already scrolled to some other item
        if (!!error && !this.isScrolledToItem) {
          this.isScrolledToItem = this.scrollTo(itemKey)
        }

        const listItemClassNames = cx({
          [classNameListItem]: !!classNameListItem,
          [styles.listItem]: true,
          [styles.listItemActive]: isActive,
          // Overwritten in colors.less
          'kiosk-color-list-item-active': isActive,
        })

        return (
          <SidebarCard
            item={item}
            title={item.name}
            isColumn={isColumn}
            isColumnReverse={isColumnReverse}
            isFullWidth={isFullWidth}
            noMargin={noMargin}
            isProfile={isProfile}
            isServices={isServices}
            isMainMenu={isMainMenu}
            isOverflown={isOverflown}
            icon={this.renderLeftIcon(item)}
            ref={ref => this.updateRefs(itemKey, ref)}
            key={itemKey}
            data-cy={item.feature}
            avatarCircle={avatarCircle}
            className={listItemClassNames}
            onClick={item.onClick ? item.onClick : this.goTo(item)}
            active={isActive && this.state.active}
            preTitle={item.topInfo}
            disabled={item.disabled}
            block={this.props.styleVariationDesktop === 'blocks'}
            variant={this.props.card}
            hidden={item.hidden}
          >
            {item.description}
          </SidebarCard>
        )
      })
    )
  }

  render() {
    const {
      className,
      styleVariationDesktop,
      styleVariation,
      textsWhiteSpace,
      attrDataQa,
      items,
      noResultsMessage,
      isColumn,
      isProfile,
      user,
    } = this.props

    if (noResultsMessage && noResultsMessage.length > 0 && !(items && items.length > 0)) {
      return <h3 className={styles.noResults}>{noResultsMessage}</h3>
    }

    const classNames = cx({
      [className]: !!className,
      [styles.list]: true,
      [styles.listStyleDesktopBlocks]: styleVariationDesktop && styleVariationDesktop === 'blocks',
      [styles.profileList]: isProfile && user,
      [styles.authList]: isProfile && !user,
      [styles.listStyleChecklist]: styleVariation && styleVariation === 'checklist',
      [styles.textsWhiteSpaceWrap]: textsWhiteSpace && textsWhiteSpace === 'wrap',
      [styles.listColumn]: isColumn,
      'kiosk--chakra-colors-background': true,
    })

    return (
      <ul className={classNames} style={this.props.style} data-qa={attrDataQa || 'list-undefined'}>
        {this.renderItems(items)}
      </ul>
    )
  }
}

List.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      // Main title
      name: PropTypes.string,
      // Text above main title
      topInfo: PropTypes.string,
      // Text below main title
      description: PropTypes.string,
      // When used for main menu
      feature: PropTypes.string,
      // When used as SvgIcon type
      // leftIcon: PropTypes.string || PropTypes.array,
      // For replacing whole left icon content
      // customContentLeft: PropTypes.elementType,
      // Element to render on the right side
      // customContentRight: PropTypes.elementType,
      // e.g. 'Checked'
      rightCheckbox: PropTypes.string,
      // Right arrow (carousel)
      // URL to open when clicked on item
      url: PropTypes.string,
      // For marking list item as required
      errorMessage: PropTypes.string,
    }),
  ).isRequired,
}

export default withRouter(List)
